window.addEventListener('DOMContentLoaded', function() {

    $(".pillar-tabs li a").on("click", function (e) {

        e.preventDefault();

        var targetTab = $(this).attr("data-target-tab");

        $(".pillar-tabs li a").removeClass("active");

        $(this).addClass("active");

      let offset_top = $("#" + targetTab).offset().top - $('.header-wrapper').height() - $(this).closest('.pillar-tabs').height() - 10;
        
        $("html,body").animate({
            scrollTop: offset_top
        }, "fast");

    });
    
    function sticky() {
        var header = $(".pillar-tabs");
        var sticky = header.offset();
        var stickyH = header.outerHeight(true);
        if ($(window).width() > 767) {
            moveSticky();
            
            function moveSticky() {
                window.onscroll = function () {
                    if (sticky != undefined) {
                        if (window.pageYOffset >= sticky.top - 10) {
                            header.addClass("tabs-sticky").parent().css('padding-top', stickyH + 'px');
                        } else {
                            header.removeClass("tabs-sticky").parent().css('padding-top', '0');
                        }
                    }
                };
            }
        } else {
            window.onscroll = function () {
                header.removeClass("tabs-sticky");
                return false;
            };
        }
    };
    window.onload = function() {
        sticky();
    };
    $(window).resize(sticky);

     $('.lets-talk-btn').on("click", function(e) {
      e.preventDefault();
      $.fancybox.open({
        src  : '#hbspt-form-talk',
        type : 'inline',
        width : '100%',
        height : 'auto',
        opts : {
          afterShow : function( ) {

          }
        }
      });
    });

    $('.lets-talk-2-btn').on("click", function(e) {
      e.preventDefault();
      $.fancybox.open({
        src  : '#hbspt-form-talk-2',
        type : 'inline',
        width : '100%',
        height : 'auto',
        opts : {
          afterShow : function( ) {

          }
        }
      });
    });
});